export default function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n';
 _.each(data.labels, function(label) { ;
__p += '\n  <span class="label label-' +
((__t = ( label.remoteName )) == null ? '' : __t) +
' js-Label">\n    ' +
((__t = ( label.name )) == null ? '' : __t) +
'\n  </span>\n';
 }); ;
__p += '\n\n';
return __p
}